var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSelectiveActiveBranco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2837_3026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.19087 5.80916C4.43416 5.56586 4.82855 5.56565 5.07211 5.80868L7.5 8.23127L9.92789 5.80868C10.1714 5.56565 10.5658 5.56586 10.8091 5.80916C11.0526 6.05264 11.0526 6.44741 10.8091 6.69089L8.20711 9.29292C7.81658 9.68344 7.18342 9.68344 6.79289 9.29292L4.19087 6.69089C3.94738 6.44741 3.94738 6.05264 4.19087 5.80916Z",
    fill: "#6796CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2837_3026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectiveActiveBranco);
export default __webpack_public_path__ + "static/media/IconSelectiveActiveBranco.3909b49efbd4b0838106d507985b2248.svg";
export { ForwardRef as ReactComponent };